module.exports = __webpack_public_path__ + "img/icon-jingdong.6106a25a.png";